module.exports = __webpack_public_path__ + "img/switch_logo_light.e56a702e.svg";